module.exports = __webpack_public_path__ + "static/media/Home 2.bb61647f.svg";